import script from "./LibraryCatalogFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./LibraryCatalogFilters.vue?vue&type=script&setup=true&lang=js"

import "./LibraryCatalogFilters.vue?vue&type=style&index=0&id=650af1fa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-650af1fa"]])

export default __exports__